<p-card [header]="title">
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12">
    <app-form-prefixed-input-mask
      [form]="form"
      [mask]="mask"
      [prefix]="prefix"
      [twoColumns]="true"
      id="tacsId"
      label="tacs®Code"></app-form-prefixed-input-mask>

    <app-form-number-input
      [form]="form"
      [twoColumns]="true"
      id="sortNumber"
      label="GLOBAL.SORT_NUMBER"></app-form-number-input>

    <app-form-date-input
      [form]="form"
      [maxDate]="maxFromDate || form.value.validTo"
      [minDate]="minFromDate"
      [twoColumns]="true"
      id="validFrom"
      label="GLOBAL.GUELTIG_AB"></app-form-date-input>

    <app-form-date-input
      [form]="form"
      [maxDate]="maxToDate"
      [minDate]="minToDate || form.value.validFrom"
      [twoColumns]="true"
      id="validTo"
      label="GLOBAL.GUELTIG_BIS"></app-form-date-input>

    <app-form-multiselect
      [form]="form"
      [options]="marketsOptions"
      [twoColumns]="true"
      id="markets"
      label="MANDANTS.MARKTS"></app-form-multiselect>

    <app-form-text-input [form]="form" [twoColumns]="true" id="name.De" label="GLOBAL.NAME_De"></app-form-text-input>

    <app-form-text-input [form]="form" [twoColumns]="true" id="name.Fr" label="GLOBAL.NAME_Fr"></app-form-text-input>

    <app-form-text-input [form]="form" [twoColumns]="true" id="name.It" label="GLOBAL.NAME_It"></app-form-text-input>

    @if (isPersonalkategorie()) {
      <app-form-text-input
        [form]="form"
        [twoColumns]="true"
        id="description.De"
        label="GLOBAL.DESCRIPTION_De"></app-form-text-input>
      <app-form-text-input
        [form]="form"
        [twoColumns]="true"
        id="description.Fr"
        label="GLOBAL.DESCRIPTION_Fr"></app-form-text-input>
      <app-form-text-input
        [form]="form"
        [twoColumns]="true"
        id="description.It"
        label="GLOBAL.DESCRIPTION_It"></app-form-text-input>
    }

    @if (isOrganisationkategorie() || isPersonalkategorie()) {
      <app-form-text-input
        [form]="form"
        [maxLength]="10"
        [twoColumns]="true"
        id="shortCode.De"
        label="GLOBAL.SHORTCODE_DE"></app-form-text-input>
      <app-form-text-input
        [form]="form"
        [maxLength]="10"
        [twoColumns]="true"
        id="shortCode.Fr"
        label="GLOBAL.SHORTCODE_FR"></app-form-text-input>
      <app-form-text-input
        [form]="form"
        [maxLength]="10"
        [twoColumns]="true"
        id="shortCode.It"
        label="GLOBAL.SHORTCODE_IT"></app-form-text-input>
    }

    @if (isOrganisationkategorie()) {
      <app-form-switch
        [form]="form"
        [twoColumns]="true"
        id="customersPersonnelTimeShifting"
        label="GLOBAL.CUSTOMER_PERSONNEL_TIME_SHIFTING"></app-form-switch>
    }

    <app-form-button-bar [form]="form" [saveDisabled]="submitting"></app-form-button-bar>
  </form>
</p-card>
